import { Calendar, MapPin, Phone, Mail, MessageCircle, ArrowRight } from 'lucide-react';

export default function Admissions() {
  return (
    <section id="admissions" className="py-20 bg-white dark:bg-gray-900 transition-colors">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <span className="inline-flex items-center px-4 py-2 rounded-full bg-pink-100 dark:bg-pink-900/30 text-pink-700 dark:text-pink-300 font-semibold text-sm mb-4">
            Admissions 2026-27
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 dark:text-white mb-4">
            Preschool Admissions 2026-27 in Chhatrapati Sambhaji Nagar
          </h2>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Families are welcome to connect with Tiny Wings Preschool to learn about available classes, school readiness and classroom experiences.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div className="bg-gradient-to-br from-pink-50 to-purple-50 dark:from-gray-800 dark:to-gray-700 rounded-3xl p-8 shadow-lg">
            <div className="flex items-center gap-3 mb-6">
              <Calendar className="w-8 h-8 text-pink-500" />
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Available Classes</h3>
            </div>
            <div className="space-y-4">
              {['Playgroup', 'Nursery', 'Junior KG', 'Senior KG'].map((className) => (
                <div key={className} className="flex items-center justify-between border-b border-pink-100 dark:border-gray-700 pb-3">
                  <span className="font-semibold text-gray-700 dark:text-gray-300">{className}</span>
                  <span className="text-pink-600 dark:text-pink-300 text-sm">Admissions open</span>
                </div>
              ))}
            </div>

            <div className="mt-8 flex flex-wrap gap-4">
              <a href="#contact" className="inline-flex items-center gap-2 bg-gradient-to-r from-pink-500 to-purple-500 text-white px-6 py-3 rounded-full font-semibold hover:shadow-lg">
                Enquire for Admission <ArrowRight className="w-4 h-4" />
              </a>
              <a href="#contact" className="inline-flex items-center gap-2 bg-white dark:bg-gray-900 text-gray-900 dark:text-white border border-pink-500 px-6 py-3 rounded-full font-semibold">
                Schedule a School Visit
              </a>
            </div>
          </div>

          <div className="bg-white dark:bg-gray-800 rounded-3xl p-8 shadow-lg border border-gray-100 dark:border-gray-700">
            <div className="flex items-center gap-3 mb-6">
              <MapPin className="w-8 h-8 text-pink-500" />
              <h3 className="text-2xl font-bold text-gray-900 dark:text-white">Admission Enquiry</h3>
            </div>
            <div className="space-y-5">
              <div className="flex items-start gap-4">
                <Phone className="w-6 h-6 text-pink-500 mt-1" />
                <div>
                  <span className="font-semibold text-gray-900 dark:text-white">Phone</span>
                  <p className="text-gray-600 dark:text-gray-300">+91 862 405 1851</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <Mail className="w-6 h-6 text-pink-500 mt-1" />
                <div>
                  <span className="font-semibold text-gray-900 dark:text-white">Email</span>
                  <p className="text-gray-600 dark:text-gray-300">info@tinywingslearning.com</p>
                </div>
              </div>
              <div className="flex items-start gap-4">
                <MapPin className="w-6 h-6 text-pink-500 mt-1" />
                <div>
                  <span className="font-semibold text-gray-900 dark:text-white">Visit us</span>
                  <p className="text-gray-600 dark:text-gray-300">Plot No. 27, Honey Bunny Building, Near Datta Mandir, Mayur Park, Jalgaon Road, Chhatrapati Sambhaji Nagar - 431003</p>
                </div>
              </div>

              <div className="bg-pink-50 dark:bg-pink-900/20 rounded-2xl p-5">
                <div className="flex items-center gap-3 mb-3">
                  <MessageCircle className="w-6 h-6 text-pink-500" />
                  <span className="font-bold text-gray-900 dark:text-white">Child Interaction</span>
                </div>
                <p className="text-gray-600 dark:text-gray-300">
                  Parents may request a school visit and speak with the team. A short interaction helps families understand the learning environment and classroom experience.
                </p>
              </div>

              <a href="#contact" className="inline-flex items-center gap-2 text-pink-600 dark:text-pink-300 font-semibold hover:text-pink-700">
                Contact Tiny Wings Preschool <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
